import { observable, action, configure, makeAutoObservable } from 'mobx';

import { Form } from '_common/components/Form/Form';
import P1_INFO from '_common/formSource/kyc/company/P1_INFO';
import P1_COMMON from '_common/formSource/kyc/person/P1_COMMON';
import P3_PHOTO from '_common/formSource/kyc/person/P3_PHOTO';
import kycService from '_common/service/kycService';
import { translate } from '_common/utils/language';
import UTIL from '_common/utils/util';

import { RenderType } from '../../okjp/constants/JpEnum';

configure({
  enforceActions: 'always',
});

/*
 * TODO:
 * 按照最新的STEP定义, 拟修改为
 * 1 -> 4 -> 3
 */
export const STEP = {
  NONE: 0,
  COMMON: 1,
  GUARDIAN: 2,
  DOCUMENTS: 3,
  PURPOSE: 4,
  DONE: 5, // 虚构用于标识newStep的，实际上后端没有这个enum
};

// 步骤运算util

export const stepForNormal = [
  STEP.NONE,
  STEP.COMMON,
  STEP.PURPOSE,
  STEP.DOCUMENTS,
  STEP.DONE,
];

export const calcNormalStep = (
  currentStep, // 当前步骤
  operator, // 运算符
  counter // 运算数字
  // eslint-disable-next-line consistent-return
) => {
  // TODO: 非需要监护人的情况没有STEP.GUARDIAN这一步，需要谨慎处理+-运算符的场景
  // 成年人的情况实际上没有step=2的场景，改造后以step=purpose+0.5代替以覆盖通用判断的场景
  const currentIndex =
    currentStep === STEP.GUARDIAN
      ? 4.5
      : stepForNormal.findIndex((T) => {
          return T === currentStep;
        });
  if (operator === '+' || operator === '-') {
    if (operator === '+' && currentIndex + counter > stepForNormal.length - 1) {
      return stepForNormal[stepForNormal.length - 1];
    }
    if (operator === '-' && currentIndex - counter < 0) {
      return stepForNormal[0];
    }
    return stepForNormal[
      operator === '+' ? currentIndex + counter : currentIndex - counter
    ];
  }
  const targetIndex =
    counter === STEP.GUARDIAN
      ? 4.5
      : stepForNormal.findIndex((T) => {
          return T === counter;
        });
  // console.log(222, currentStep, operator, counter, currentIndex, targetIndex);
  if (operator === '>') {
    return currentIndex > targetIndex;
  }
  if (operator === '>=') {
    return currentIndex >= targetIndex;
  }
  if (operator === '<') {
    return currentIndex < targetIndex;
  }
  if (operator === '<=') {
    return currentIndex <= targetIndex;
  }
};

export default class okcoinKycStoreCorporate {
  constructor(rootStore) {
    makeAutoObservable(this, {
      renderType: observable,
      companyBaseInfo: observable,
      streetList: observable,
      streetList1: observable,
      streetList2: observable,
      streetList3: observable,
      careerLvOneList: observable,
      extraCareerPersonList: observable,
      initData: observable,
      baseInfo: observable,
      rekycConfig: observable,
      isShowRekycNotification: observable,
      type: observable,
      step: observable,
      newStep: observable,
      status: observable,
      saveOne: observable,
      saveTwo: observable,
      saveThree: observable,
      currSubmitStep: observable,
      tabIndex: observable,
      countryList: observable,
      firstRenderType: observable,
      isInsider: observable,
      selectedInsiderCoinIdList: observable,
      insiderCoinList: observable,
      insiderRelation: observable,
      clauseInfoList: observable,
      residenceIsJapan: observable,
      isSameLegalAsDirector: observable,
      firstRender: observable,
      getTemplate: action,
      getCompanyTemplate: action,
      getInitInfo: action,
      getBaseInfo: action,
      getCountry: action,
      getPersonCareer: action,
      getExtraPersonCareer: action,
      getCompanyCareer: action,
      getCompanyInfo: action,
      getInsiderCoinList: action,
      onSaveCallback: action,
      onNextStepCallback: action,
      setCountryList: action,
      setSaveOne: action,
      setSaveTwo: action,
      setSaveThree: action,
      setTabIndex: action,
      setInitData: action,
      setIsSameLegalAsDirector: action,
      setNewStep: action,
      setStep: action,
      setRenderType: action,
      setStreetList1: action,
      setStreetList2: action,
      setStreetList3: action,
      setBaseInfo: action,
      setFirstRenderType: action,
      setCurrSubmitStep: action,
      setStatus: action,
      setStreetList: action,
      setCareerLvOneList: action,
      setExtraCareerPersonList: action,
      setCompanyBaseInfo: action,
      setType: action,
      setFirstRender: action,
      setIsInsider: action,
      setSelectedInsiderCoinId: action,
      setSelectedInsiderCoinIdList: action,
      setInsiderRelation: action,
      setInsiderCoinList: action,
      clearInsiderInfo: action,
      setClause: action,
      setClauseInfo: action,
      changeResidence: action,
    });

    this.loadingStore = rootStore.loadingStore;
  }

  renderType = 999; // 0：初始状态  1：渲染状态 2：显示状态
  companyBaseInfo = {}; // 企业数据容器

  streetList = []; // 街道 数据源  本人基本信息用
  streetList1 = []; // 街道1 数据源  监护人1用
  streetList2 = []; // 街道2 数据源 监护人2 用
  streetList3 = []; // 法人街道 数据源 用

  careerLvOneList = [];
  extraCareerPersonList = [];

  initData = {};
  baseInfo = {};
  rekycConfig = {};
  isShowRekycNotification = false;

  type = '';
  step = '';
  newStep = '';
  status = '';
  saveOne = '';
  saveTwo = '';
  saveThree = '';
  currSubmitStep = '';

  tabIndex = {};

  countryList = []; // 国籍国家列表

  firstRenderType = 999;

  isInsider = 0; // 是否是内部者，0：否，1：是
  selectedInsiderCoinIdList = []; // 作为内部者的虚拟货币
  insiderCoinList = []; // insiderCoinList from DB
  insiderRelation = ''; // 内部者与所选择虚拟货币的关系
  clauseInfoList = []; // 个人基本信息里的协议

  residenceIsJapan = true;
  isSameLegalAsDirector = 0;

  // 增加首次加载监听(首次加载的时候需要处理跳转到最近未保存步骤的逻辑)
  firstRender = false;

  /**
   * 获取个人模板
   * @returns {Array|*|void}
   */
  getTemplate() {
    let template = [];
    switch (this.newStep) {
      case STEP.NONE || STEP.COMMON:
        template = UTIL.deepCopy(P1_COMMON());
        break;
      case 2: // STEP.DOCUMENTS TODO
        template = UTIL.deepCopy(P3_PHOTO());
        break;
      case STEP.DOCUMENTS:
        template = UTIL.deepCopy(P3_PHOTO());
        break;
      case STEP.PURPOSE:
        break;
      default:
        break;
    }
    template = Form.conversion(template); // 转换为formLine 使用的数据模板
    return template;
  }

  /**
   * 获取企业模板
   * @returns {Array|*|void}
   */
  getCompanyTemplate() {
    let template = [];
    const haveFilledPurpose = 2;
    switch (this.newStep) {
      case STEP.NONE || STEP.COMMON:
        template = UTIL.deepCopy(P1_INFO());
        break;
      case haveFilledPurpose: // STEP.DOCUMENTS 历史遗留问题 step是判断已完成的步骤，即使是在成年人的场景下也还是会有step=2的情况，需要特别注意调转顺序后已经填写取引目的的情况
        template = UTIL.deepCopy(P3_PHOTO());
        break;
      case STEP.DOCUMENTS:
        template = UTIL.deepCopy(P3_PHOTO());
        break;
      case STEP.PURPOSE:
        break;
      default:
        break;
    }
    template = Form.conversion(template); // 转换为formLine 使用的数据模板
    return template;
  }

  isAllStepDone = (_step) => {
    return calcNormalStep(_step, '>=', STEP.DOCUMENTS); // TODO
  };

  /**
   * 获取初始化信息
   */
  async getInitInfo(next) {
    this.loadingStore.showLoading();
    await this.getInsiderCoinList();
    const res = await kycService.getInitInfoV2Corp();
    this.loadingStore.hideLoading();
    const infoData = res.data || {};

    let saveOne = false;
    let saveTwo = false;
    let saveThree = false;

    let { step } = infoData;
    const {
      isFilledPersonalInfo,
      isFilledPurpose,
      isUploadFileInfo,
      type,
      isSameLegalAsDirector,
    } = infoData;

    // 再kyc状态，需要获取类型
    const resRekycInfo = await kycService.getRekycInfo();
    const rekycInfo = resRekycInfo.data || {};
    this.setRekycConfig(rekycInfo);

    if (isUploadFileInfo) {
      step = STEP.DOCUMENTS;
    } else if (isFilledPurpose) {
      step = STEP.PURPOSE;
    } else if (isFilledPersonalInfo) {
      step = STEP.COMMON;
    } else {
      step = STEP.NONE;
    }
    const originalStep = step;
    // 当 状态为 8，也是拒绝，保持和 3一致
    let kycStatus = infoData.status;
    if (kycStatus === 8) {
      kycStatus = 3;
    }
    // 修正：因为老的逻辑原因，非监护人上传好证件之后step会变成2，不符合预期，手动修正为3
    if (step === STEP.GUARDIAN) {
      step = STEP.DOCUMENTS;
    }
    this.setType(type);

    if (calcNormalStep(originalStep, '>=', STEP.COMMON)) {
      saveOne = true;
    }
    if (calcNormalStep(originalStep, '>=', STEP.PURPOSE)) {
      saveTwo = true;
    }
    if (calcNormalStep(originalStep, '>=', STEP.DOCUMENTS)) {
      saveThree = true;
    }

    // TODO: 首次加载的时候需要处理跳转到最近未保存步骤的逻辑(有待完善)
    // kyc处于被打回的状态不需要跳转
    if (this.firstRender === false) {
      if (kycStatus !== 0 && kycStatus !== undefined) {
        this.setFirstRender(true);
      } else if (
        (step === STEP.COMMON && saveOne) ||
        (step === STEP.PURPOSE && saveTwo) ||
        (step === STEP.DOCUMENTS && saveThree)
      ) {
        // 权宜之计，待下一步修改
        step = calcNormalStep(step, '+', 1);
      }
    }

    // 判断是否需要监护人
    const tabIndex = {};
    tabIndex.trade = 2;
    tabIndex.card = 3;
    tabIndex.submit = 4;
    this.setStatus(kycStatus);
    this.setSaveOne(saveOne);
    this.setSaveTwo(saveTwo);
    this.setSaveThree(saveThree);
    this.setTabIndex(tabIndex);
    this.setInitData(infoData);
    this.setIsSameLegalAsDirector(isSameLegalAsDirector);
    this.setStep(step || STEP.NONE);
    if (kycStatus == 0 || kycStatus === 3) {
      this.setNewStep(step || STEP.COMMON);
    } else {
      // KYC提出不可のため、active tabを一つもどす。
      this.setNewStep(calcNormalStep(step, '-', 1));
    }

    // 保存直後は該当stepを表示する
    // if (this.currSubmitStep != '' && this.currSubmitStep < step) {
    //   this.setNewStep(this.currSubmitStep);
    // }
    const resCompareStep = calcNormalStep(this.currSubmitStep, '<', step);
    if (this.currSubmitStep != '' && resCompareStep) {
      this.setNewStep(this.currSubmitStep);
    }

    // 保存直後は該当stepを優先
    if (
      this.currSubmitStep == '' &&
      this.isAllStepDone(step) &&
      this.firstRender !== false
    ) {
      // 提出可能な状態であればstep1をdefault表示, step3の取引目的を修正することはあまりないため。
      this.setNewStep(1);
    }

    this.setFirstRender(true);

    if (type === 0) {
      // 根据step判断要获取哪页的数据
      switch (this.newStep) {
        case STEP.COMMON:
          this.getBaseInfo();
          break;
        case STEP.GUARDIAN:
          break;
        default:
          // this.getBaseInfo();
          break;
      }
    } else if (type === 1) {
      // 根据step判断要获取哪页的数据
      switch (this.newStep) {
        case STEP.COMMON:
          this.getCompanyInfo();
          break;
        default:
          break;
      }
    }
    if (typeof next === 'function') {
      if (rekycInfo.oddType === 2 && rekycInfo.infoUpdated === 0) {
        next(STEP.DOCUMENTS);
      } else {
        next(STEP.COMMON);
      }
    }
  }

  /**
   * 获取基本信息
   * @returns {Promise<void>}
   */
  async getBaseInfo() {
    this.setRenderType(999); // 重置 renderType

    if (this.step === 0) {
      this.setRenderType(0);
      return;
    }

    this.loadingStore.showLoading();
    const res = await kycService.getBaseInfoCorp(this.initData.businessType);
    this.loadingStore.hideLoading();
    if (res.code === 0 && res.data) {
      this.setRenderType(RenderType.SHOW);
      const baseInfo = res.data;

      // TODO 是否是内部者和协议，假数据填充，接口添加字段后改为真正的字段
      const { isInsider, insiderCoin, insiderCoinRelation, agreeProtocol } =
        baseInfo;
      const selectedInsiderCoinIdList = insiderCoin.split(',');
      const clauseInfoList = agreeProtocol.split(',');
      this.setIsInsider(isInsider);
      this.setSelectedInsiderCoinIdList(selectedInsiderCoinIdList);
      this.setInsiderRelation(insiderCoinRelation);
      this.setClauseInfo(clauseInfoList);

      const { postCode, career } = baseInfo;
      // 解析职业数据
      const careers = career && career.split(',');
      if (careers && careers.length > 0) {
        baseInfo.careerLvOne = careers[0];

        this.getPersonCareer();
      }
      this.setBaseInfo(baseInfo);
      // 根据postCode 获取
      const addressRes = await kycService.getAddressByPostCode({ postCode });
      const streetList = [];
      addressRes.data.forEach((addressItem) => {
        streetList.push({
          value: addressItem.street,
          label: addressItem.street,
        });
      });
      this.setStreetList(streetList);
    } else {
      this.setRenderType(RenderType.INPUT);
    }
  }

  /**
   * 获取国家信息
   * @returns {Promise<void>}
   */
  async getCountry() {
    const res = await kycService.getKycCountryNew();
    const countryList = [];
    const primeCountryList = [];
    let JapanData = null;
    let ChinaData = null;
    res &&
      res.data &&
      res.data.forEach((item) => {
        const label = `${translate(item.id)} ${
          item.status === 1
            ? ''
            : ` (${translate('user.page.countryNoSupport')})`
        }`;

        if (item.id == 4567) {
          JapanData = {
            value: item.id,
            label,
            disabled: !item.status,
          };
        } else if (item.id == 4518) {
          ChinaData = {
            value: item.id,
            label,
            disabled: !item.status,
          };
        } else {
          countryList.push({
            value: item.id,
            label,
            disabled: !item.status,
          });
        }
      });
    primeCountryList.push(JapanData);
    primeCountryList.push(ChinaData);
    this.setCountryList(primeCountryList.concat(countryList));
  }

  /**
   * 获取职业信息
   * @returns {Promise<void>}
   */
  async getPersonCareer() {
    const res = await kycService.getPersonCareer();
    const careerList = [];
    res &&
      res.data &&
      res.data.forEach((item) => {
        careerList.push({
          value: item.id,
          label: translate(item.id),
        });
      });
    this.setCareerLvOneList(careerList);
  }

  /**
   * 获取职业信息 - extra(用于实质支配者个人的职种列表)
   * @returns {Promise<void>}
   */
  async getExtraPersonCareer() {
    const res = await kycService.getPersonCareer();
    const careerList = [];
    res &&
      res.data &&
      res.data.forEach((item) => {
        careerList.push({
          value: item.id,
          label: translate(item.id),
        });
      });
    this.setExtraCareerPersonList(careerList);
  }

  /**
   *
   * @returns {Promise<void>}
   */
  async getCompanyCareer() {
    const res = await kycService.getCompanyCareer();
    const careerList = [];
    res &&
      res.data &&
      res.data.forEach((item) => {
        careerList.push({
          value: item.id,
          label: translate(item.id),
        });
      });
    this.setCareerLvOneList(careerList);
  }

  /**
   * 获取企业基本信息
   * @returns {Promise<void>}
   */
  async getCompanyInfo(forceJump) {
    this.setRenderType(999);
    this.loadingStore.showLoading();
    const res = await kycService.getBaseInfoCorp(this.initData.businessType);
    this.loadingStore.hideLoading();
    if (
      res &&
      res.code === 0 &&
      res.data &&
      Object.entries(res.data).length > 0
    ) {
      // 解析企业基本信息 / Analyze basic business information
      const companyBaseInfo = res.data;
      const {
        careerType,
        companyLegal,
        companyDirector,
        shareholders,
        tenureReason,
        postCode,
        isInsider,
        insiderCoin,
        insiderCoinRelation,
      } = companyBaseInfo;

      // 针对在留信息做调整
      if (
        companyLegal?.residenceType === 0 &&
        companyLegal?.residenceValidity === ''
      ) {
        // 既存数据修复
        companyLegal.residenceType = null;
      }
      if (
        companyDirector?.residenceType === 0 &&
        companyDirector?.residenceValidity === ''
      ) {
        // 既存数据修复
        companyDirector.residenceType = null;
      }
      if (
        companyLegal?.countryCode === '4567' ||
        this.initData?.isSameLegalAsDirector === 0
      ) {
        companyLegal.residenceType = null;
      }
      if (
        companyDirector?.countryCode === '4567' ||
        this.initData?.isSameLegalAsDirector === 1
      ) {
        companyDirector.residenceType = null;
      }

      const selectedInsiderCoinIdList = insiderCoin.split(',');
      this.setIsInsider(isInsider);
      this.setSelectedInsiderCoinIdList(selectedInsiderCoinIdList);
      this.setInsiderRelation(insiderCoinRelation);

      // 处理居住地 / Handling residence
      // companyLegal.residence = `${companyLegal.residence}`;

      const directorPostCode = companyDirector.postCode;
      const legalPostCode = companyLegal.postCode;
      if (shareholders && shareholders.length > 0) {
        const shareholdersListValue = shareholders.map((item) => {
          return UTIL.deepCopy(item);
        });
        companyBaseInfo.shareholdersListValue = shareholdersListValue;
      }
      delete companyBaseInfo.companyDirector;
      delete companyBaseInfo.companyLegal;
      delete companyBaseInfo.shareholders;

      // 处理企业业务类型 / Handling business type
      if (careerType) {
        companyBaseInfo.careerLvOne = careerType;
      }

      // 处理担当者 / Dealer
      if (companyDirector) {
        companyBaseInfo.firstName = companyDirector.firstName;
        companyBaseInfo.lastName = companyDirector.lastName;
        companyBaseInfo.firstNamePy = companyDirector.firstNamePy;
        companyBaseInfo.lastNamePy = companyDirector.lastNamePy;
        companyBaseInfo.firstNameEn = companyDirector.firstNameEn;
        companyBaseInfo.lastNameEn = companyDirector.lastNameEn;

        Object.entries(companyDirector).forEach((item) => {
          companyBaseInfo[`director${item[0]}`] = item[1];
        });
      }

      // 处理法人 / Handling legal person
      if (companyLegal) {
        Object.entries(companyLegal).forEach((item) => {
          companyBaseInfo[`legal${item[0]}`] = item[1];
        });
      }

      // 处理股东信息 / Handling shareholder information
      if (shareholders) {
        let messageText = '';
        let maxNum = 3;
        if (tenureReason && tenureReason === 1) {
          messageText = translate('jp.company.share25');
        } else if (tenureReason && tenureReason === 2) {
          messageText = translate('jp.company.share50');
          maxNum = 1;
        }
        const inputList = shareholders.map((item, index) => {
          const info = {
            id: item.id,
            cardTitle: `${translate('jp.company.share')}-${index + 1}`,
            inputAttr: {
              primaryText: `${item.lastName} ${item.firstName}`,
              messageList: [
                {
                  text: messageText,
                  type: 'company-share-message',
                },
              ],
            },
          };
          return info;
        });

        const currNum = inputList.length;
        for (let i = 0; i < maxNum - currNum; i++) {
          inputList.push({});
        }
        companyBaseInfo.shareholders = inputList;
      }

      this.setCompanyBaseInfo(companyBaseInfo);
      this.setRenderType(RenderType.SHOW);

      // 处理街道地址 / Handling street addresses
      const addressRes = await kycService.getAddressByPostCode({ postCode });
      const streetList1 = [];
      if (addressRes.data && addressRes.data.length > 0) {
        addressRes.data.forEach((addressItem) => {
          streetList1.push({
            value: addressItem.street,
            label: addressItem.street,
          });
        });
      }
      this.setStreetList1(streetList1);

      // 再处理担当者地址 / Reprocessing the address of the person in charge
      const derAddressRes = await kycService.getAddressByPostCode({
        postCode: directorPostCode,
      });
      const streetList2 = [];
      if (derAddressRes.data && derAddressRes.data.length > 0) {
        derAddressRes.data.forEach((addressItem) => {
          streetList2.push({
            value: addressItem.street,
            label: addressItem.street,
          });
        });
      }
      this.setStreetList2(streetList2);

      // 再处理法人地址 / Reprocessing the address of the person in charge
      const legalAddressRes = await kycService.getAddressByPostCode({
        postCode: legalPostCode,
      });
      const streetList3 = [];
      if (legalAddressRes.data && legalAddressRes.data.length > 0) {
        legalAddressRes.data.forEach((addressItem) => {
          streetList3.push({
            value: addressItem.street,
            label: addressItem.street,
          });
        });
      }
      this.setStreetList3(streetList3);
      // 在留资格导致的再KYC/ODD体系导致的再KYC选择了変更あり这两者之后的弹窗，点击确认需要直接进入编辑状态
      if (
        forceJump &&
        (this.rekycConfig?.reKycType === 0 ||
          this.rekycConfig?.infoUpdated === 1)
      ) {
        this.setRenderType(RenderType.INPUT);
        window.scrollTo({
          top: 0,
          behavior: 'smooth',
        });
      }
    } else {
      this.setRenderType(RenderType.INPUT);
    }
  }

  /**
   * Get InsiderCoinList from DB
   * @param
   */
  async getInsiderCoinList() {
    const res = await kycService.getInsiderCoinList();
    const filterJPYList = [];
    if (res.data && res.data.length > 0) {
      res.data = res.data.map((T) => {
        // 新旧接口字段不一样，为了避免大幅度修改，沿用旧字段
        const newT = T;
        const { isUnifiedAccount } = window.okGlobal;
        if (!isUnifiedAccount) {
          newT.id = T.baseCurrencyId;
          newT.symbol = T.baseCurrencySymbol;
        }
        return newT;
      });
      res.data.forEach((coin) => {
        if (coin.symbol !== 'JPY') {
          filterJPYList.push(coin);
        }
      });
    }
    this.setInsiderCoinList(filterJPYList);
  }

  /**
   * 每一级别保存响应
   * @param step
   */
  onSaveCallback(step) {
    this.setCurrSubmitStep(step); // 设置当前提交步数
    this.getInitInfo();
  }

  /**
   * 每一级别下一步响应
   * @param step
   */
  onNextStepCallback(nextStep) {
    if (this.needGuardian && nextStep === 2) {
      this.getGuardian();
    }
    this.setCurrSubmitStep('');
    this.setNewStep(nextStep);
  }

  setCountryList(list) {
    this.countryList = list;
  }

  setSaveOne(flag) {
    this.saveOne = flag;
  }

  setSaveTwo(flag) {
    this.saveTwo = flag;
  }

  setSaveThree(flag) {
    this.saveThree = flag;
  }

  setTabIndex(flag) {
    this.tabIndex = flag;
  }

  setInitData(data) {
    this.initData = data;
  }

  setRekycConfig(data) {
    this.rekycConfig = {
      ...data,
      ts: Date.now(),
    };
  }

  setIsShowRekycNotification(data) {
    this.isShowRekycNotification = data;
  }

  setIsSameLegalAsDirector(data) {
    this.isSameLegalAsDirector = data;
  }

  setNewStep(step) {
    this.newStep = step;
  }

  setStep(step) {
    this.step = step;
  }

  setRenderType(type) {
    this.renderType = type;
  }

  setStreetList1(list) {
    this.streetList1 = list;
  }

  setStreetList2(list) {
    this.streetList2 = list;
  }

  setStreetList3(list) {
    this.streetList3 = list;
  }

  setBaseInfo(info) {
    this.baseInfo = info;
  }

  setFirstRenderType(type) {
    this.firstRenderType = type;
  }

  setCurrSubmitStep(step) {
    this.currSubmitStep = step;
  }

  setStatus(status) {
    this.status = status;
  }

  setStreetList(streetList) {
    this.streetList = streetList;
  }

  setCareerLvOneList(careerLvOneList) {
    this.careerLvOneList = careerLvOneList;
  }

  setExtraCareerPersonList(extraCareerPersonList) {
    this.extraCareerPersonList = extraCareerPersonList;
  }

  setCompanyBaseInfo(companyBaseInfo) {
    this.companyBaseInfo = companyBaseInfo;
  }

  setType(type) {
    this.type = type;
  }

  setFirstRender(firstRender) {
    this.firstRender = firstRender;
  }

  // 初始化时设置是否是内部者
  setIsInsider = (isInsider) => {
    this.isInsider = isInsider;
  };

  // 点击多选选按钮时设置是否是内部者
  setSelectedInsiderCoinId = (insiderCheckBox) => {
    this.selectedInsiderCoinIdList = [];
    insiderCheckBox.forEach((item) => {
      if (item.check) {
        this.selectedInsiderCoinIdList.push(String(item.id));
      }
    });
  };

  // 设置内部者虚拟币列表信息
  setSelectedInsiderCoinIdList = (selectedInsiderCoinIdList) => {
    this.selectedInsiderCoinIdList = selectedInsiderCoinIdList;
  };

  // 设置内部者和虚拟币的关系
  setInsiderRelation = (insiderRelation) => {
    this.insiderRelation = insiderRelation;
  };

  // Set insiderCoinList
  setInsiderCoinList = (insiderCoinList) => {
    this.insiderCoinList = insiderCoinList;
  };

  // 不是内部者时，清空内部者虚拟币列表信息和虚拟币的关系
  clearInsiderInfo = () => {
    this.setSelectedInsiderCoinIdList([]);
    this.setInsiderRelation('');
  };

  // 操作多选框时设置本人条款信息
  setClause = (clauseInfo) => {
    this.clauseInfoList = [];
    clauseInfo.forEach((item) => {
      if (item.check) {
        this.clauseInfoList.push(item.id);
      }
    });
  };

  // 初始化时设置本人条款信息
  setClauseInfo = (clauseInfoList) => {
    this.clauseInfoList = clauseInfoList;
  };

  changeResidence = (flag) => {
    this.residenceIsJapan = flag;
  };
}
